import React, { useContext } from 'react';
import { Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { MainHeader } from '@eposnow/ui-core';
import Stepper from './Stepper';
import { StepContext } from '../../context/StepContext';

const PageHeader = ({
  header,
  description,
  omitTextHeader = false,
}: {
  header?: string;
  description?: string;
  omitTextHeader?: boolean;
}) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const { currentStepIndex, steps } = useContext(StepContext);

  return (
    <>
      <Stepper
        currentStepIndex={currentStepIndex}
        steps={steps}
      />

      {!omitTextHeader && (
        <MainHeader
          title={header || t(`steps.${steps?.[currentStepIndex]?.stepKey}.header`)}
          styles={{
            marginTop: { xs: 0, sm: 3, md: 2 },
            marginBottom: { xs: 3, sm: 4 },
            alignContent: 'start',
          }}
          theme={theme}
        >
          <Typography>
            {description || t(`steps.${steps?.[currentStepIndex]?.stepKey}.description`)}
          </Typography>
        </MainHeader>
      )}
    </>
  );
};

export default PageHeader;
